import {createStyles, TextField, Theme, WithStyles, withStyles } from '@material-ui/core'
//import SearchIcon from '@material-ui/icons/Search'
import * as React from 'react'

interface SearchPartnershipsFormProps extends WithStyles<typeof styles> {
	onPartnershipsSearch: (firstName: string) => void
	searching: boolean
}

interface SearchPartnershipsFormState {
	firstName: string
}

export class SearchPartnershipsForm extends React.Component<SearchPartnershipsFormProps, SearchPartnershipsFormState> {
	state: SearchPartnershipsFormState = {
		firstName: '',
	}

	private formRef: React.RefObject<HTMLFormElement> = React.createRef()

	validate = () => {
		const form = this.formRef.current

		return form ? form.reportValidity() : false
	}

	handleTextChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		const { name, value } = e.target
    if(name === 'firstName'){
      this.props.onPartnershipsSearch(value)
    }
		this.setState((prevState: SearchPartnershipsFormState) => Object.assign({}, prevState, { [name]: value }))
	}

	onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault()
		const isFormValid = this.validate()

		if (isFormValid) {
			const { firstName } = this.state

			this.props.onPartnershipsSearch(firstName)
		}
	}

	render() {
		const { classes, searching } = this.props
		const { firstName } = this.state

		return (
			<div className={classes.root}>
				<form onSubmit={this.onFormSubmit} ref={this.formRef} className={classes.searchForm} autoComplete="off" data-auto="search-partnerships-form">
					<TextField
						disabled={searching}
						value={firstName || ''}
						autoFocus={true}
						id="first-name"
						name="firstName"
						label="Name"
						className={classes.textField}
						margin="dense"
						variant="outlined"
						inputProps={{
							maxLength: 25,
							'data-auto': 'input-firstName',
						}}
						onChange={this.handleTextChange}
					/>
					{/* <TextField
						disabled={searching}
						value={lastName || ''}
						required={true}
						id="last-name"
						name="lastName"
						margin="dense"
						label="Last Name"
						className={classes.textField}
						variant="outlined"
						inputProps={{
							maxLength: 25,
							pattern: "^[A-z ,.'-]+$",
							'data-auto': 'input-lastName',
						}}
						onChange={this.handleTextChange}
					/> */}
					{/* <Button type="submit" variant="contained" color="default" className={classes.searchButton} data-auto="search-partnerships-button">
						<SearchIcon className={classes.icon} />
						Search
					</Button> */}
				</form>
			</div>
		)
	}
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			width:'27em'
		},
		searchForm: {
			display: 'flex',
			justifyContent: 'left',

			[theme.breakpoints.down('xs')]: {
				flexDirection: 'column',
				justifyContent: 'center',
			},
		},
		textField: {
			display: 'flex',
			marginRight: theme.spacing.unit * 3,

			[theme.breakpoints.down('lg')]: {
				width: '100%',
			},
		},
		searchButton: {
			height: '100%',
			alignSelf: 'center',
			[theme.breakpoints.down('xs')]: {
				marginTop: theme.spacing.unit * 1,
			},
		},
		icon: {
			fontSize: theme.typography.fontSize * 1.5,
			padding: `0 ${theme.spacing.unit * 2}`,
		},
	})

export default withStyles(styles)(SearchPartnershipsForm)
